<template>
  <div v-if="!loading">
    <b-form-group :label="$t('field.name')">
      <b-form-input
        v-model="item.name"
        name="name"
        type="text"
        required
        placeholder="Lorem ipsum set dolor"
      />
    </b-form-group>
    <b-form-group :label="$t('field.email')">
      <b-form-input
        v-model="item.email"
        name="email"
        type="email"
        required
        placeholder="lorem@ipsum.dolor"
      />
    </b-form-group>
    <b-form-group :label="$t('field.phone')">
      <b-form-input
        v-model="item.phone"
        name="phone"
        type="text"
        required
        placeholder="123456789"
      />
    </b-form-group>
  </div>
  <div v-else>
    <spinner />
  </div>
</template>

<script>
import contactsApi from '@/api/contacts'
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    contactsApi,
    loading: true
  }),
  computed: {
    ...mapGetters({
      item: 'form/relationshipFields'
    })
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      this.loading = false
    }
  }
}
</script>
